/* Ardor proof sheet: one proof layout for the banner, A-frame, yard sign and canvas builders. Ardor Printing, Oct 9 2026.
   Same look as the event tent builder's proof (style "ardor-proof-1"): landscape letter, the 3D view on page 1 with the
   order details and the approval box, and the print file drawn to scale next to the 3D view when there is room, or on page 2.
   It also adds the "PDF" button to the builder's tool rail: it makes an unsigned proof preview and downloads it.
   Loaded last by each builder section. A builder calls ArdorProofSheet.build(proof) -> Promise<Blob> and offers
   window.Ardor<Name>Builder.proof = { noun, file, stamp(date), make() -> Promise<Blob> } for the PDF button. */
(function () {
'use strict';
if (window.ArdorProofSheet) return;

var PW = 792, PH = 612, M = 36;
var C = { red: '#BD252C', ink: '#0C0D0D', muted: '#6B6F76', panel: '#F6F4F1', rule: '#DCDDE0', safe: '#3B6FD4', signature: '#33363B', grommet: '#B8BABF' };
var Z = { title: 22, panelHeading: 13, headerDate: 10, pageTitle: 10, approvalTag: 9.5, body: 9, detail: 8, small: 7.5, fine: 6.5, rowMin: 6, cellTitleMin: 5.5 };
var ADDRESS = 'Ardor Printing | 12531 Old Snohomish Monroe Rd., Snohomish, WA 98290 | (425) 629-0796 | ardorprinting.com';
var VIEW_W = 1000, VIEW_H = 1030;

// ---------- small helpers ----------
function latin1Bytes(s) { var b = new Uint8Array(s.length); for (var i = 0; i < s.length; i++) b[i] = s.charCodeAt(i) & 255; return b; }
function concat(chunks) { var n = 0; chunks.forEach(function (c) { n += c.length; }); var o = new Uint8Array(n), p = 0; chunks.forEach(function (c) { o.set(c, p); p += c.length; }); return o; }
function num(n) { if (!isFinite(n)) n = 0; var r = Math.round(n * 1000) / 1000; return (Math.abs(r) < 1e-9 ? 0 : r).toString(); }
function deflate(bytes) {
var cs = new CompressionStream('deflate');
var w = cs.writable.getWriter(); w.write(bytes); w.close();
return new Response(cs.readable).arrayBuffer().then(function (ab) { return new Uint8Array(ab); });
}
function rgb(hex) { var n = parseInt(String(hex || '#000000').slice(1), 16); return num(((n >> 16) & 255) / 255) + ' ' + num(((n >> 8) & 255) / 255) + ' ' + num((n & 255) / 255); }

// WinAnsi text for the standard Helvetica fonts
var WIN = { 0x2022: 0x95, 0x2013: 0x96, 0x2014: 0x97, 0x2018: 0x91, 0x2019: 0x92, 0x201C: 0x93, 0x201D: 0x94, 0x2026: 0x85, 0x20AC: 0x80, 0x2122: 0x99 };
function pdfText(s) {
var out = '';
for (var i = 0; i < s.length; i++) {
var c = s.charCodeAt(i), b;
if (c < 128) b = c; else if (c >= 0xA0 && c <= 0xFF) b = c; else if (WIN[c]) b = WIN[c]; else b = 63;
var ch = String.fromCharCode(b);
if (ch === '(' || ch === ')' || ch === '\\') ch = '\\' + ch;
out += ch;
}
return '(' + out + ')';
}
// Helvetica widths (per 1000 em)
var HW = [278,278,355,556,556,889,667,191,333,333,389,584,278,333,278,278,556,556,556,556,556,556,556,556,556,556,278,278,584,584,584,556,1015,667,667,722,722,667,611,778,722,278,500,667,556,833,722,778,667,778,722,667,611,722,667,944,667,667,611,278,278,278,469,556,333,556,556,500,556,556,278,556,556,222,222,500,222,833,556,556,556,556,333,500,278,556,500,722,500,500,500,334,260,334,584];
var HBW = [278,333,474,556,556,889,722,238,333,333,389,584,278,333,278,278,556,556,556,556,556,556,556,556,556,556,333,333,584,584,584,611,975,722,722,722,722,667,611,778,722,278,556,722,611,833,722,778,667,778,722,667,611,722,667,944,667,667,611,333,278,333,584,556,333,556,611,556,611,556,333,611,611,278,278,556,278,889,611,611,611,611,389,556,333,611,556,778,556,556,500,389,280,389,584];
function textWidth(s, size, bold) { var t = bold ? HBW : HW, w = 0; s = String(s); for (var i = 0; i < s.length; i++) { var c = s.charCodeAt(i); w += (c >= 32 && c < 127) ? t[c - 32] : 556; } return w * size / 1000; }
function wrap(s, size, bold, maxW) {
var lines = [];
String(s == null ? '' : s).split(/\n/).forEach(function (para) {
var words = para.split(/\s+/).filter(Boolean), cur = '';
words.forEach(function (w) {
// a single word longer than the line is cut so it cannot run off the page
while (textWidth(w, size, bold) > maxW && w.length > 1) {
if (cur) { lines.push(cur); cur = ''; }
var k = w.length - 1; while (k > 1 && textWidth(w.slice(0, k), size, bold) > maxW) k--;
lines.push(w.slice(0, k)); w = w.slice(k);
}
var t = cur ? cur + ' ' + w : w;
if (textWidth(t, size, bold) <= maxW || !cur) cur = t; else { lines.push(cur); cur = w; }
});
if (cur) lines.push(cur);
});
return lines.length ? lines : [''];
}

// ---------- PDF writer ----------
function Doc() { this.objs = [null]; }
Doc.prototype.alloc = function () { this.objs.push(null); return this.objs.length - 1; };
Doc.prototype.set = function (id, dict, stream) { this.objs[id] = { dict: dict, stream: stream || null }; return id; };
Doc.prototype.add = function (dict, stream) { return this.set(this.alloc(), dict, stream); };
Doc.prototype.bytes = function (rootId, infoId) {
var chunks = [], off = 0, offsets = [0];
var push = function (b) { chunks.push(b); off += b.length; };
push(latin1Bytes('%PDF-1.6\n%\xE2\xE3\xCF\xD3\n'));
for (var i = 1; i < this.objs.length; i++) {
var o = this.objs[i] || { dict: 'null' };
offsets[i] = off;
if (o.stream) {
var d = o.dict.replace(/\s*>>\s*$/, '') + ' /Length ' + o.stream.length + ' >>';
push(latin1Bytes(i + ' 0 obj\n' + d + '\nstream\n')); push(o.stream); push(latin1Bytes('\nendstream\nendobj\n'));
} else push(latin1Bytes(i + ' 0 obj\n' + o.dict + '\nendobj\n'));
}
var xref = off, n = this.objs.length, x = 'xref\n0 ' + n + '\n0000000000 65535 f \n';
for (var j = 1; j < n; j++) x += String(offsets[j]).padStart(10, '0') + ' 00000 n \n';
x += 'trailer\n<< /Size ' + n + ' /Root ' + rootId + ' 0 R' + (infoId ? ' /Info ' + infoId + ' 0 R' : '') + ' >>\nstartxref\n' + xref + '\n%%EOF\n';
push(latin1Bytes(x));
return concat(chunks);
};

// ---------- images ----------
function toCanvas(src, w, h, bg) {
var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
var ctx = cv.getContext('2d');
if (bg) { ctx.fillStyle = bg; ctx.fillRect(0, 0, w, h); }
ctx.imageSmoothingQuality = 'high';
ctx.drawImage(src, 0, 0, w, h);
return cv;
}
// opaque picture -> JPEG object. maxLong keeps the file small.
function addJpeg(doc, src, maxLong, q) {
var sw = src.naturalWidth || src.width, sh = src.naturalHeight || src.height;
if (!sw || !sh) return Promise.resolve(null);
var k = Math.min(1, maxLong / Math.max(sw, sh)), w = Math.max(1, Math.round(sw * k)), h = Math.max(1, Math.round(sh * k));
var cv = toCanvas(src, w, h, '#FFFFFF');
return new Promise(function (res) { cv.toBlob(function (b) { res(b); }, 'image/jpeg', q || 0.9); }).then(function (b) {
if (!b) return null;
return b.arrayBuffer().then(function (ab) {
var id = doc.add('<< /Type /XObject /Subtype /Image /Width ' + w + ' /Height ' + h + ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode >>', new Uint8Array(ab));
return { id: id, w: w, h: h };
});
});
}
// picture with transparency (logo, signature) -> Flate image with a soft mask
function addRgba(doc, src, maxLong) {
var sw = src.naturalWidth || src.width, sh = src.naturalHeight || src.height;
if (!sw || !sh) return Promise.resolve(null);
var k = Math.min(1, maxLong / Math.max(sw, sh)), w = Math.max(1, Math.round(sw * k)), h = Math.max(1, Math.round(sh * k));
var data = toCanvas(src, w, h, null).getContext('2d').getImageData(0, 0, w, h).data;
var col = new Uint8Array(w * h * 3), al = new Uint8Array(w * h), hasA = false;
for (var i = 0, p = 0; i < w * h; i++, p += 4) {
var a = data[p + 3]; al[i] = a; if (a !== 255) hasA = true;
// un-premultiply is not needed (getImageData is straight alpha); fully clear pixels become white
if (a === 0) { col[i * 3] = 255; col[i * 3 + 1] = 255; col[i * 3 + 2] = 255; }
else { col[i * 3] = data[p]; col[i * 3 + 1] = data[p + 1]; col[i * 3 + 2] = data[p + 2]; }
}
return Promise.all([deflate(col), hasA ? deflate(al) : Promise.resolve(null)]).then(function (z) {
var smask = '';
if (z[1]) { var sid = doc.add('<< /Type /XObject /Subtype /Image /Width ' + w + ' /Height ' + h + ' /ColorSpace /DeviceGray /BitsPerComponent 8 /Filter /FlateDecode >>', z[1]); smask = ' /SMask ' + sid + ' 0 R'; }
var id = doc.add('<< /Type /XObject /Subtype /Image /Width ' + w + ' /Height ' + h + ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /FlateDecode' + smask + ' >>', z[0]);
return { id: id, w: w, h: h };
});
}

// ---------- one page of drawing commands. Positions are in points from the TOP-left, like the tent proof. ----------
function Page() { this.ops = []; this.xo = []; this.n = 0; }
Page.prototype.text = function (x, y, s, size, bold, color, align) {
s = String(s == null ? '' : s);
var w = align ? textWidth(s, size, bold) : 0;
if (align === 'right') x -= w; else if (align === 'center') x -= w / 2;
this.ops.push('BT /' + (bold ? 'F2' : 'F1') + ' ' + num(size) + ' Tf ' + rgb(color || C.ink) + ' rg ' + num(x) + ' ' + num(PH - y) + ' Td ' + pdfText(s) + ' Tj ET');
};
Page.prototype.lines = function (x, y, arr, size, bold, color, lead) { var self = this; arr.forEach(function (ln, i) { self.text(x, y + i * lead, ln, size, bold, color); }); };
// text that reads bottom to top, centred on y, with its baseline on x
Page.prototype.textUp = function (x, y, s, size, bold, color) {
var w = textWidth(s, size, bold);
this.ops.push('BT /' + (bold ? 'F2' : 'F1') + ' ' + num(size) + ' Tf ' + rgb(color || C.ink) + ' rg 0 1 -1 0 ' + num(x) + ' ' + num(PH - y - w / 2) + ' Tm ' + pdfText(s) + ' Tj ET');
};
Page.prototype.line = function (x1, y1, x2, y2, w, color, dash) {
this.ops.push('q ' + rgb(color || C.ink) + ' RG ' + num(w) + ' w ' + (dash ? '[' + dash + '] 0 d ' : '') + num(x1) + ' ' + num(PH - y1) + ' m ' + num(x2) + ' ' + num(PH - y2) + ' l S Q');
};
Page.prototype.rect = function (x, y, w, h, fill, stroke, lw) {
this.ops.push('q ' + (fill ? rgb(fill) + ' rg ' : '') + (stroke ? rgb(stroke) + ' RG ' + num(lw || 1) + ' w ' : '') + num(x) + ' ' + num(PH - y - h) + ' ' + num(w) + ' ' + num(h) + ' re ' + (fill && stroke ? 'B' : (fill ? 'f' : 'S')) + ' Q');
};
Page.prototype.dot = function (x, y, r, fill) {
var c = 0.5523 * r, Y = PH - y;
this.ops.push('q ' + rgb(fill) + ' rg ' + num(x + r) + ' ' + num(Y) + ' m ' + num(x + r) + ' ' + num(Y + c) + ' ' + num(x + c) + ' ' + num(Y + r) + ' ' + num(x) + ' ' + num(Y + r) + ' c ' + num(x - c) + ' ' + num(Y + r) + ' ' + num(x - r) + ' ' + num(Y + c) + ' ' + num(x - r) + ' ' + num(Y) + ' c ' + num(x - r) + ' ' + num(Y - c) + ' ' + num(x - c) + ' ' + num(Y - r) + ' ' + num(x) + ' ' + num(Y - r) + ' c ' + num(x + c) + ' ' + num(Y - r) + ' ' + num(x + r) + ' ' + num(Y - c) + ' ' + num(x + r) + ' ' + num(Y) + ' c f Q');
};
Page.prototype.image = function (obj, x, y, w, h) {
if (!obj) return;
var nm = '/Im' + (++this.n);
this.ops.push('q ' + num(w) + ' 0 0 ' + num(h) + ' ' + num(x) + ' ' + num(PH - y - h) + ' cm ' + nm + ' Do Q');
this.xo.push(nm + ' ' + obj.id + ' 0 R');
};

// ---------- pieces of the sheet ----------
function drawHeader(p, o, logo) {
if (logo) { var lh = 38, lw = lh * logo.w / logo.h; if (lw > 190) { lw = 190; lh = lw * logo.h / logo.w; } p.image(logo, M, 30 + (38 - lh) / 2, lw, lh); }
else p.text(M, 58, 'ARDOR PRINTING', 20, true, C.ink);
p.text(PW - M, 56, o.title || 'Ardor Proof', Z.title, true, C.ink, 'right');
p.text(PW - M, 71, o.date || '', Z.headerDate, false, C.muted, 'right');
p.line(M, 84, PW - M, 84, 0.75, C.red);
}
function drawFooter(p, o, n, total) {
p.line(M, 546, PW - M, 546, 0.5, C.rule);
p.text(M, 558, o.footer || ADDRESS, Z.small, false, C.ink);
p.text(PW - M, 558, 'Page ' + n + ' of ' + total, Z.small, false, C.muted, 'right');
p.lines(M, 569, wrap(o.disclaimer, Z.fine, false, PW - M * 2).slice(0, 2), Z.fine, false, C.muted, 7.5);
}
function drawLegend(p, o, y) {
var x = M;
var item = function (kind, color, label) {
if (kind === 'dot') p.dot(x + 9, y - 2.5, 3.2, color);
else p.line(x, y - 2.5, x + 18, y - 2.5, kind === 'dash' ? 0.6 : 0.8, color, kind === 'dash' ? '2.5 2' : null);
p.text(x + 23, y, label, Z.small, false, C.muted);
x += 23 + textWidth(label, Z.small, false) + 16;
};
item('line', C.ink, 'Print edge');
if (o.kind === 'banner') { item('dot', C.grommet, 'Grommet'); item('dash', C.ink, 'Hem / pocket fold'); }
var t = [o.legend, o.note].filter(Boolean).join(' ');
if (t) p.lines(x, y, wrap(t, Z.small, false, PW - M - x).slice(0, 2), Z.small, false, C.muted, 9);
}
function drawCheck(p, x, y, on) {
p.rect(x, y, 8, 8, null, C.ink, 0.6);
if (on) { p.line(x + 1.6, y + 4.2, x + 3.6, y + 6.8, 1, C.ink); p.line(x + 3.6, y + 6.8, x + 7.6, y + 1.4, 1, C.ink); }
}
function drawApproval(p, o, sig, y, h) {
var a = M, ap = o.approval;
p.rect(a, y, 470, h, null, C.red, 1);
p.text(a + 12, y + 17, ap ? 'APPROVED FOR PRINTING' : (o.preview ? 'PROOF PREVIEW, NOT YET APPROVED' : 'NOT YET APPROVED'), Z.approvalTag, true, ap ? C.red : C.muted);
if (!ap) {
var note = o.preview
? 'This is a preview of your proof. When you add your ' + o.noun + ' to the cart, you\'ll review it, sign it and confirm that printed colors may vary slightly from your screen. Nothing is printed until your proof is signed.'
: (o.unsignedNote || 'This proof has not been signed. Ardor Printing will email you a proof to approve, and nothing is printed until you approve it.');
p.lines(a + 12, y + 38, wrap(note, Z.body, false, 446), Z.body, false, C.ink, 10.4);
return;
}
var sx = a + 12, sy = y + 86;
if (sig) { var k = Math.min(190 / sig.w, 52 / sig.h); p.image(sig, sx, sy - 4 - sig.h * k, sig.w * k, sig.h * k); }
if (!ap.later) p.line(sx, sy, sx + 190, sy, 0.6, C.signature); // DSN: approval box now, typed signature in the cart
p.text(sx, sy + 13, ap.later ? 'Approved online (approval box checked)' : (ap.name || 'Name'), Z.body, true, C.ink);
p.text(sx, sy + 25, (ap.later ? 'Approved ' : (ap.method === 'typed' ? 'Typed signature ' : 'Signed ')) + (ap.when || ''), Z.small, false, C.muted);
var l = a + 234;
p.text(l, y + 34, wrap(ap.later ? 'Name and typed signature: added in the cart' : 'Email: ' + (ap.email || ''), Z.detail, false, 224)[0], Z.detail, false, C.ink);
p.text(l, y + 47, wrap(ap.later ? 'Email and phone: from checkout' : 'Phone: ' + (ap.phone || ''), Z.detail, false, 224)[0], Z.detail, false, C.ink);
var d = y + 62;
(ap.statements && ap.statements.length ? ap.statements : ['I understand printed colors may vary slightly from what I see on my screen.', 'I approve this proof for printing as shown.']).forEach(function (st) {
drawCheck(p, l, d - 6.5, true);
var ls = wrap(st, Z.small, false, 210);
p.lines(l + 13, d, ls, Z.small, false, C.ink, 9.5);
d += ls.length * 9.5 + 8;
});
}
function drawPanel(p, o, rows) {
var x = 522, w = PW - M - x;
p.rect(x, 96, w, 416, C.panel, null);
p.text(x + 12, 116, o.panelTitle, Z.panelHeading, true, C.ink);
var valW = w - 24 - 74, size = Z.detail, laid = [];
for (; size >= Z.rowMin; size -= 0.5) {
laid = rows.map(function (r) { return { label: wrap(r[0], size, true, 68), lines: wrap(r[1], size, false, valW) }; });
var need = 132 + laid.reduce(function (s, r) { return s + Math.max(r.lines.length, r.label.length) * size * 1.22 + size * 0.75; }, 0);
if (need <= 504) break;
}
if (size < Z.rowMin) size = Z.rowMin;
var y = 134;
laid.forEach(function (r) {
var n = Math.max(r.lines.length, r.label.length), hgt = n * size * 1.22 + size * 0.75;
if (y + (n - 1) * size * 1.22 > 506) return; // out of room: leave the row out rather than run off the panel
p.lines(x + 12, y, r.label, size, true, C.muted, size * 1.22);
p.lines(x + 86, y, r.lines, size, false, C.ink, size * 1.22);
y += hgt;
});
}
// a flat print-file drawing with its print edge and its width and height, inside the box x,y,w,h
function drawFace(p, f, img, x, y, w, h, mid) {
var left = 18, right = 4, bottom = 20;
var s = Math.min((w - left - right) / f.wIn, (h - bottom) / f.hIn), dw = f.wIn * s, dh = f.hIn * s;
var dx = x + left + (w - left - right - dw) / 2, dy = y + (mid ? (h - bottom - dh) / 2 : 0);
if (img) p.image(img, dx, dy, dw, dh); else p.rect(dx, dy, dw, dh, '#FFFFFF', null);
p.rect(dx, dy, dw, dh, null, C.ink, 0.7);
var by = dy + dh + 6;
p.line(dx, by, dx + dw, by, 0.5, C.muted); p.line(dx, by - 2.5, dx, by + 2.5, 0.5, C.muted); p.line(dx + dw, by - 2.5, dx + dw, by + 2.5, 0.5, C.muted);
p.text(dx + dw / 2, by + 9, f.wLabel || (num(f.wIn) + ' in'), Z.fine, false, C.muted, 'center');
var lx = dx - 6;
p.line(lx, dy, lx, dy + dh, 0.5, C.muted); p.line(lx - 2.5, dy, lx + 2.5, dy, 0.5, C.muted); p.line(lx - 2.5, dy + dh, lx + 2.5, dy + dh, 0.5, C.muted);
p.textUp(lx - 3, dy + dh / 2, f.hLabel || (num(f.hIn) + ' in'), Z.fine, false, C.muted);
return { x: dx, y: dy, w: dw, h: dh };
}
// page 2: the best grid for the drawings (same rule as the tent proof)
function gridFor(faces, area, labelH) {
var best = { cols: 1, scale: 0 };
for (var cols = 1; cols <= faces.length; cols++) {
var rws = Math.ceil(faces.length / cols), cw = (area.w - (cols - 1) * 16) / cols, ch = (area.h - (rws - 1) * 12) / rws;
var sc = Math.min.apply(null, faces.map(function (f) { return Math.min((cw - 22) / f.wIn, (ch - labelH - 20) / f.hIn); }));
if (sc > best.scale * 1.0001) best = { cols: cols, scale: sc };
}
return best;
}

// ---------- the proof ----------
// o: { title, date, panelTitle, noun, kind, logo, views:[{canvas, caption}], faces:[{label, canvas, fallback, wIn, hIn, wLabel, hLabel}],
//      specs:[[label, value]], legend, note, footer, approval|null, preview, unsignedNote }
function build(o) {
o = o || {};
try { if (typeof api._hook === 'function') api._hook('views'); } catch (e) {}
var doc = new Doc();
var fonts = '/F1 ' + doc.add('<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica /Encoding /WinAnsiEncoding >>') + ' 0 R /F2 ' + doc.add('<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold /Encoding /WinAnsiEncoding >>') + ' 0 R';
var faces = (o.faces || []).filter(function (f) { return f && f.wIn > 0 && f.hIn > 0; });
var views = (o.views || []).filter(function (v) { return v && v.canvas; }).slice(0, 2);
o.noun = o.noun || 'sign'; o.panelTitle = o.panelTitle || 'Your sign';
o.disclaimer = o.disclaimer || ('Colors on screen and on this proof may differ slightly from the printed ' + o.noun + '. ' + (views.length ? 'The 3D view is a guide; the print file drawing shows the exact size.' : 'The print file drawing shows the exact size.'));
var SLOT = { x: [M, M + 241], y: 114, w: 229, h: 229 * VIEW_H / VIEW_W };
// "next to it if there is room": one print file, and it still reads well at the size of the second box
var roomBeside = function (f) { var s = Math.min((SLOT.w - 22) / f.wIn, (SLOT.h - 20) / f.hIn), a = f.wIn * s, b = f.hIn * s; return Math.max(a, b) >= 150 && Math.min(a, b) >= 88; };
var beside = views.length > 0 && faces.length === 1 && roomBeside(faces[0]);
var inBoxes = views.length === 0 && faces.length > 0 && faces.length <= 2; // no 3D picture: the print files take the two boxes
var second = faces.length > 0 && !beside && !inBoxes;
var total = second ? 2 : 1;
var faceSrc = function (f) { return f.fallback || f.canvas; };

return Promise.all([
o.logo ? addRgba(doc, o.logo, 900).catch(function () { return null; }) : Promise.resolve(null),
Promise.all(views.map(function (v) { return addJpeg(doc, v.canvas, 1400, 0.9).catch(function () { return null; }); })),
Promise.all(faces.map(function (f) { return faceSrc(f) ? addJpeg(doc, faceSrc(f), 1800, 0.9).catch(function () { return null; }) : Promise.resolve(null); })),
(o.approval && o.approval.sig) ? addRgba(doc, o.approval.sig, 1000).catch(function () { return null; }) : Promise.resolve(null)
]).then(function (im) {
var logo = im[0], viewIm = im[1], faceIm = im[2], sig = im[3];
var pagesOut = [];

// page 1
var p = new Page();
drawHeader(p, o, logo);
var boxes = [];
if (inBoxes) faces.forEach(function (f, i) { boxes.push({ face: f, img: faceIm[i] }); });
else if (beside) { boxes.push({ view: views[0], img: viewIm[0] }); boxes.push({ face: faces[0], img: faceIm[0] }); }
else views.forEach(function (v, i) { boxes.push({ view: v, img: viewIm[i] }); });
var headAt = function (x, bold, soft) { p.text(x, 106, bold, Z.body, true, C.ink); if (soft) p.text(x + textWidth(bold, Z.body, true) + 6, 106, soft, Z.detail, false, C.muted); };
if (boxes.length && boxes[0].view) headAt(M, o.panelTitle + ' in 3D');
else if (boxes.length) headAt(M, faces.length > 1 ? 'Print files' : 'Print file', faces.length > 1 ? 'drawn to scale, as they print' : 'drawn to scale, as it prints');
else headAt(M, o.panelTitle);
boxes.forEach(function (b, i) {
var x = SLOT.x[i];
if (b.view) {
if (b.img) p.image(b.img, x, SLOT.y, SLOT.w, SLOT.h);
p.rect(x, SLOT.y, SLOT.w, SLOT.h, null, C.rule, 0.5);
if (b.view.caption) p.text(x + SLOT.w / 2, SLOT.y + SLOT.h + 11, b.view.caption, Z.small, false, C.muted, 'center');
} else {
if (i > 0 && boxes[0].view) headAt(x, 'Print file', 'drawn to scale, as it prints');
var bw = (inBoxes && faces.length === 1) ? 470 : SLOT.w; // alone with no 3D picture: use both boxes
drawFace(p, b.face, b.img, x, SLOT.y, bw, SLOT.h, true);
if (b.face.label) p.text(x + bw / 2, SLOT.y + SLOT.h + 11, wrap(b.face.label, Z.small, false, bw)[0], Z.small, false, C.muted, 'center');
}
});
drawApproval(p, o, sig, 374, 138);
var rows = (o.specs || []).map(function (r) { return [String(r[0]), String(r[1] == null ? '' : r[1])]; });
if (faces.length) rows.push(['Print file' + (faces.length > 1 ? 's' : ''), (faces.length > 1 ? faces.length + ' print files' : '1 print file') + ', drawn to scale ' + (second ? 'on page 2' : 'on this page')]);
drawPanel(p, o, rows);
drawLegend(p, o, 528);
drawFooter(p, o, 1, total);
pagesOut.push(p);

// page 2: the print files, drawn to scale
if (second) {
var q = new Page();
drawHeader(q, o, logo);
var ttl = faces.length > 1 ? 'Print files' : 'Print file';
q.text(M, 106, ttl, Z.pageTitle, true, C.ink);
q.text(M + textWidth(ttl, Z.pageTitle, true) + 8, 106, faces.length + (faces.length > 1 ? ' files, drawn to scale, as they print' : ' file, drawn to scale, as it prints'), Z.detail, false, C.muted);
var area = { x: M, y: 116, w: PW - M * 2, h: 392 }, labelH = 15, g = gridFor(faces, area, labelH);
var rws = Math.ceil(faces.length / g.cols), cw = (area.w - (g.cols - 1) * 16) / g.cols, ch = (area.h - (rws - 1) * 12) / rws;
faces.forEach(function (f, i) {
var cx = area.x + (i % g.cols) * (cw + 16), cy = area.y + Math.floor(i / g.cols) * (ch + 12);
var r = drawFace(q, f, faceIm[i], cx, cy + labelH, cw, ch - labelH, false);
q.text(Math.max(cx, r.x), cy + 9, f.label || ('Side ' + (i + 1)), Z.detail, true, C.ink);
});
drawLegend(q, o, 520);
var tag = o.approval ? 'APPROVED FOR PRINTING' : (o.preview ? 'PROOF PREVIEW, NOT YET APPROVED' : 'NOT YET APPROVED');
q.text(M, 537, tag, Z.small, true, o.approval ? C.red : C.muted);
if (o.approval) q.text(M + textWidth(tag, Z.small, true) + 6, 537, (o.approval.later ? 'online ' + (o.approval.when || '') + ' (approval box; name and typed signature added in the cart)' : 'by ' + (o.approval.name || '') + ', ' + (o.approval.method === 'typed' ? 'typed signature' : 'signed') + ' ' + (o.approval.when || '') + ' (signature on page 1)'), Z.small, false, C.ink);
drawFooter(q, o, 2, total);
pagesOut.push(q);
}

return Promise.all(pagesOut.map(function (pg) { return deflate(latin1Bytes(pg.ops.join('\n'))); })).then(function (zs) {
var pagesId = doc.alloc();
var kids = pagesOut.map(function (pg, i) {
var cid = doc.add('<< /Filter /FlateDecode >>', zs[i]);
return doc.add('<< /Type /Page /Parent ' + pagesId + ' 0 R /MediaBox [0 0 ' + PW + ' ' + PH + '] /Resources << /ProcSet [/PDF /Text /ImageB /ImageC] /Font << ' + fonts + ' >>' + (pg.xo.length ? ' /XObject << ' + pg.xo.join(' ') + ' >>' : '') + ' >> /Contents ' + cid + ' 0 R >>');
});
doc.set(pagesId, '<< /Type /Pages /Kids [' + kids.map(function (k) { return k + ' 0 R'; }).join(' ') + '] /Count ' + kids.length + ' >>');
var root = doc.add('<< /Type /Catalog /Pages ' + pagesId + ' 0 R >>');
var d = new Date(), pad = function (n) { return String(n).padStart(2, '0'); };
var ds = 'D:' + d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate()) + pad(d.getHours()) + pad(d.getMinutes()) + pad(d.getSeconds());
var creator = (o.title || 'Ardor Proof').replace(/ Proof$/, '') + ' Builder';
var inf = doc.add('<< /Title ' + pdfText((o.title || 'Ardor Proof') + (o.date ? ' ' + o.date : '')) + ' /Subject ' + pdfText(o.title || 'Ardor Proof') + ' /Author (Ardor Printing) /Creator ' + pdfText(creator) + ' /Producer ' + pdfText(creator) + ' /Keywords (ardor-proof-1) /CreationDate (' + ds + ') >>');
return new Blob([doc.bytes(root, inf)], { type: 'application/pdf' });
});
});
}

// ---------- the PDF button and its small window ----------
var ICON = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 4v11m0 0 4.5-4.5M12 15l-4.5-4.5M4 19.5h16"/></svg>';
var CHECK = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
var CSS = '' +
'.aps-dialog{border:0;padding:0;border-radius:16px;width:min(594px,calc(100vw - 32px));max-width:none;background:#fff;color:#0C0D0D;box-shadow:0 24px 70px rgba(0,0,0,.28);font-family:Jost,"Helvetica Neue",Arial,sans-serif;font-size:15px;line-height:1.45;letter-spacing:0;text-transform:none}' +
'.aps-dialog::backdrop{background:rgba(12,13,13,.45)}' +
'.aps-dialog *{box-sizing:border-box}' +
'.aps-head{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:18px 20px 6px}' +
'.aps-head h2{margin:0;font:700 17px/1.3 Inter,"Helvetica Neue",Arial,sans-serif;letter-spacing:0;text-transform:none;color:#0C0D0D}' +
'.aps-x{appearance:none;border:0;background:none;width:34px;height:34px;border-radius:8px;font-size:24px;line-height:1;color:#33363B;cursor:pointer}' +
'.aps-x:hover{background:#F2F2F3}' +
'.aps-steps{list-style:none;margin:0;padding:6px 20px 16px;display:grid;gap:12px}' +
'.aps-steps li{display:flex;align-items:center;gap:10px;margin:0;color:#33363B}' +
'.aps-num{flex:none;display:grid;place-items:center;width:22px;height:22px;border-radius:50%;border:1px solid #C9CBD0;font:600 11px/1 Inter,Arial,sans-serif;color:#6B6F76;background:#fff}' +
'.aps-steps li.is-on .aps-num{border-color:#0C0D0D;color:#0C0D0D}' +
'.aps-steps li.is-done{color:#0C0D0D}' +
'.aps-steps li.is-done .aps-num{border-color:#1E8E3E;background:#1E8E3E;color:#fff}' +
'.aps-steps li.is-done .aps-num b{display:none}' +
'.aps-steps li:not(.is-done) .aps-num svg{display:none}' +
'.aps-result{border-top:1px solid #E6E7EA;padding:16px 20px 14px}' +
'.aps-ready{display:flex;align-items:center;gap:8px;margin:0 0 10px;font-weight:600;font-size:17px;color:#1E8E3E}' +
'.aps-note{margin:0;font-size:13px;color:#6B6F76}' +
'.aps-error{margin:0;padding:0 20px 14px;font-size:13px;color:#BD252C}' +
'.aps-foot{display:flex;justify-content:flex-end;gap:8px;padding:14px 20px;border-top:1px solid #E6E7EA}' +
'.aps-btn{appearance:none;display:inline-flex;align-items:center;gap:8px;min-height:40px;padding:0 16px;border-radius:10px;border:1px solid #DCDDE0;background:#fff;color:#0C0D0D;font:700 14px/1 Inter,"Helvetica Neue",Arial,sans-serif;letter-spacing:0;text-transform:none;cursor:pointer}' +
'.aps-btn:hover{background:#F6F6F7}' +
'.aps-btn--dark{background:#141517;border-color:#141517;color:#fff}' +
'.aps-btn--dark:hover{background:#000}' +
'.aps-btn svg{width:18px;height:18px}' +
'.aps-dialog [hidden]{display:none!important}' +
// seven tools or more in the side rail (banner, A-frame): keep them all on screen on shorter computer screens
'@media (min-width:990px) and (max-height:960px){.abb--app .abx-rail:has(> .abx-tool ~ .abx-tool ~ .abx-tool ~ .abx-tool ~ .abx-tool ~ .abx-tool ~ .abx-tool){gap:2px;padding:10px 8px}.abb--app .abx-rail:has(> .abx-tool ~ .abx-tool ~ .abx-tool ~ .abx-tool ~ .abx-tool ~ .abx-tool ~ .abx-tool) .abx-rail-logo{padding:2px 0 10px;margin-bottom:4px}.abb--app .abx-rail:has(> .abx-tool ~ .abx-tool ~ .abx-tool ~ .abx-tool ~ .abx-tool ~ .abx-tool ~ .abx-tool) .abx-tool{gap:4px;padding:9px 4px;font-size:14px}.abb--app .abx-rail:has(> .abx-tool ~ .abx-tool ~ .abx-tool ~ .abx-tool ~ .abx-tool ~ .abx-tool ~ .abx-tool) .abx-tool>span{min-height:0}}' +
'@media (min-width:990px) and (max-height:720px){.abb--app .abx-rail:has(> .abx-tool ~ .abx-tool ~ .abx-tool ~ .abx-tool ~ .abx-tool ~ .abx-tool ~ .abx-tool) .abx-tool{gap:3px;padding:6px 4px;font-size:13px}}' +
'@media (max-width:749px){.abx-rail [data-abb-pdf]{display:none!important}}';
function addCss() {
if (document.querySelector('style[data-aps]')) return;
var st = document.createElement('style'); st.setAttribute('data-aps', ''); st.textContent = CSS; document.head.appendChild(st);
}
function fileStamp(d) {
var pad = function (n) { return String(n).padStart(2, '0'); }, h = d.getHours(), ap = h >= 12 ? 'PM' : 'AM', h12 = h % 12 || 12;
return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + pad(h12) + '-' + pad(d.getMinutes()) + ' ' + ap;
}
function saveBlob(blob, name) {
var url = URL.createObjectURL(blob), a = document.createElement('a');
a.href = url; a.download = name; a.style.display = 'none';
document.body.appendChild(a); a.click();
setTimeout(function () { try { document.body.removeChild(a); URL.revokeObjectURL(url); } catch (e) {} }, 60000);
}
var busy = false;
function openPreview(P) {
if (busy) return;
addCss();
var noun = P.noun || 'sign';
var dlg = document.createElement('dialog'); dlg.className = 'aps-dialog'; dlg.setAttribute('aria-labelledby', 'ApsTitle');
dlg.innerHTML =
'<div class="aps-head"><h2 id="ApsTitle">Your proof (preview)</h2><button type="button" class="aps-x" data-aps-close aria-label="Close">&times;</button></div>' +
'<ol class="aps-steps">' +
'<li class="is-on" data-aps-step="1"><span class="aps-num"><b>1</b>' + CHECK + '</span><span>Rendering your ' + noun + ' in 3D</span></li>' +
'<li data-aps-step="2"><span class="aps-num"><b>2</b>' + CHECK + '</span><span>Making your proof preview (PDF)</span></li>' +
'</ol>' +
'<div class="aps-result" data-aps-result hidden><p class="aps-ready">' + CHECK + '<span>Your proof preview is ready</span></p><p class="aps-note">It isn\'t signed yet. When you add your ' + noun + ' to the cart, you\'ll review this proof and sign it before checkout.</p></div>' +
'<p class="aps-error" data-aps-error role="alert" hidden></p>' +
'<div class="aps-foot"><button type="button" class="aps-btn" data-aps-again hidden>' + ICON + '<span>Download again</span></button><button type="button" class="aps-btn aps-btn--dark" data-aps-done>Cancel</button></div>';
document.body.appendChild(dlg);
var $ = function (s) { return dlg.querySelector(s); };
var step = function (n, cls) { var li = $('[data-aps-step="' + n + '"]'); if (li) { li.classList.remove('is-on', 'is-done'); if (cls) li.classList.add(cls); } };
var gone = false, blob = null, name = '';
var close = function () { gone = true; busy = false; api._hook = null; try { if (dlg.open && dlg.close) dlg.close(); } catch (e) {} if (dlg.parentNode) dlg.parentNode.removeChild(dlg); };
$('[data-aps-close]').addEventListener('click', close);
$('[data-aps-done]').addEventListener('click', close);
dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
$('[data-aps-again]').addEventListener('click', function () { if (blob) saveBlob(blob, name); });
if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
busy = true;
api._hook = function (w) { if (!gone && w === 'views') { step(1, 'is-done'); step(2, 'is-on'); } };
var fail = function () {
if (gone) return;
busy = false; api._hook = null;
step(1, ''); step(2, '');
var er = $('[data-aps-error]'); er.textContent = 'We couldn\'t make your proof preview. Please try again, or call us at (425) 629-0796.'; er.hidden = false;
$('[data-aps-done]').textContent = 'Done';
};
// let the window paint before the work starts
setTimeout(function () {
var work;
try { work = Promise.resolve(P.make()); } catch (e) { work = Promise.reject(e); }
work.then(function (b) {
if (gone) return;
if (!b) return fail();
busy = false; api._hook = null;
blob = b; name = (P.file || 'Ardor Proof Preview') + ' ' + (typeof P.stamp === 'function' ? P.stamp(new Date()) : fileStamp(new Date())) + '.pdf';
step(1, 'is-done'); step(2, 'is-done');
$('[data-aps-result]').hidden = false; $('[data-aps-again]').hidden = false; $('[data-aps-done]').textContent = 'Done';
saveBlob(blob, name);
try { (window.dataLayer = window.dataLayer || []).push({ event: 'ardor_proof_preview', product: noun }); } catch (e) {}
}, fail);
}, 60);
}

var BUILDERS = ['ArdorBannerBuilder', 'ArdorAFrameBuilder', 'ArdorYardSignBuilder', 'ArdorCanvasBuilder'];
function mount() {
var left = 0;
BUILDERS.forEach(function (k) {
var B = window[k];
if (!B || !B.proof || typeof B.proof.make !== 'function' || B.proof._btn) return;
var root = document.querySelector('[data-abb-root]'), rail = root && root.querySelector('.abx-rail');
if (!rail) { left++; return; }
addCss();
var btn = document.createElement('button');
btn.type = 'button'; btn.className = 'abx-tool'; btn.setAttribute('data-abb-pdf', ''); btn.title = 'Download a PDF proof preview';
btn.innerHTML = ICON + '<span>PDF</span>';
var q = rail.querySelector('[data-abx-quote]');
if (q && q.nextSibling) rail.insertBefore(btn, q.nextSibling); else rail.appendChild(btn);
btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openPreview(B.proof); });
B.proof._btn = btn;
});
return left;
}

var api = { build: build, preview: openPreview, mount: mount, version: 'ardor-proof-1', _hook: null };
window.ArdorProofSheet = api;
var tries = 0;
(function again() { var left = mount(); if ((left || !BUILDERS.some(function (k) { return window[k] && window[k].proof && window[k].proof._btn; })) && ++tries < 80) setTimeout(again, 150); })();
})();
